module.exports = __webpack_public_path__ + "static/media/grand_mum_talking_01.c6378fb1.gif";